import { Tabs, TabsProps } from "antd";
import { ReactNode } from "react";
import styles from "./PageTabs.module.scss";

export interface PageTabsProps extends TabsProps {
  right?: ReactNode;
  noLine?: boolean;
  noLeftMargin?: boolean;
}

export default function PageTabs({ right, noLeftMargin, noLine, ...tabProps }: PageTabsProps) {
  return (
    <div
      className={[
        styles.PageTabs,
        noLine && styles["no-line"],
        noLeftMargin && styles["no-left-margin"],
        tabProps.className,
      ].join(" ")}
    >
      <div className={styles.left}>
        <Tabs
          animated={false}
          {...tabProps}
        />
      </div>
      {right && <div className={styles.right}>{right}</div>}
    </div>
  );
}
